import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Config } from '../../common/config';
import axios from 'axios';
import AlertModal from '../../components/alertModal';
import { translations } from '../../data/translation';

export default function IdSearch(props) {
  const navigate = useNavigate();
  const language = useSelector(state => state.language.language);
  const t = translations[language];

  const [modalOpen, setModalOpen] = useState(false); //모달 상태 관리 : 기본값 - 닫힘
  const [modalInfo, setModalInfo] = useState({
    isCancel: false,
    isConfirm: true,
    isMessage: true,
    headerMsg: '',
    actionFlag: '',
    mainMsg: '',
    action: '',
    isPercent: false,
  });
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const openModal = e => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const doModal = () => {
    setModalOpen(false);
  };

  const checkUserData = () => {
    if (!name) {
      modalInfo.mainMsg = t.nameRequired;
      return false;
    }
    if (!email) {
      modalInfo.mainMsg = t.emailRequired;
      return false;
    }

    return true;
  };

  const validateEmail = () => {
    // 빈 문자열 검사
    if (!email) {
      return false;
    }

    // 이메일 형식 검사
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
  };

  const idSearch = async () => {
    try {
      if (checkUserData() === true) {
        if (validateEmail() === true) {
          // 아이디 찾기
          const userData = { adminName: name, email: email };
          modalInfo.mainMsg = t.idSearchSending;
          modalInfo.isConfirm = false;
          openModal();
          const ret = await axios.post(
            `${process.env.REACT_APP_API_SERVER_ADMIN}searchId`,
            userData
          );

          if (ret?.data) {
            navigate('/login-idsearch-done');
          }
        } else {
          setModalInfo({
            ...modalInfo,
            mainMsg: t.emailInvalid,
            isConfirm: true,
            isCancel: false,
          });
          setModalOpen(true);
        }
      } else {
        setModalInfo({ ...modalInfo, isConfirm: true, isCancel: false });
        setModalOpen(true);
      }
    } catch (error) {
      closeModal();
      const status = error?.response?.status;
      const message =
        status === 404
          ? t.storeAdminNotFound
          : t.requestError;
      setModalInfo({
        ...modalInfo,
        mainMsg: message,
        isConfirm: true,
        isCancel: false,
      });
      setModalOpen(true);
    }
  };

  useEffect(() => {}, []);

  return (
    <>
      <AlertModal
        open={modalOpen}
        close={closeModal}
        action={doModal}
        header={modalInfo.headerMsg}
        isConfirm={modalInfo.isConfirm}
        isMessage={modalInfo.isMessage}
        isCancel={modalInfo.isCancel}
      >
        {modalInfo.mainMsg}
      </AlertModal>

      <section className="location_box">
        <ul className="location_001">
          <li>{t.home}</li>
          <li>{t.idSearch}</li>
        </ul>
      </section>

      <main>
        <section className="contants_box_04">
          <article className="signup_07">
            <h2 className="tit_01">{t.idSearch}</h2>
            <small>
              {t.idSearchHint}
            </small>
          </article>

          <article className="contants_box_03">
            <table className="login_box">
              <tbody>
                <tr>
                  <th>{t.name}</th>
                  <td>
                    <input
                      className="input_03"
                      type="text"
                      name=""
                      maxLength={80}
                      onChange={e => {
                        setName(e.target.value);
                      }}
                      value={name}
                    />
                  </td>
                </tr>
                <tr>
                  <th>{t.email}</th>
                  <td>
                    <input
                      className="input_03"
                      type="text"
                      name=""
                      maxLength={80}
                      onChange={e => {
                        setEmail(e.target.value);
                      }}
                      value={email}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </article>

          <div className="signup_08">
            <article className="button_box_01">
              <NavLink to={`${Config.SHOPADMIN_SERVER}/login`}>
                <button
                  type="button"
                  className="button_01 button_07 button_gray_line"
                >
                  {t.login}
                </button>
              </NavLink>
              <button
                type="button"
                className="button_01 button_07 button_red"
                onClick={idSearch}
              >
                {t.idSearch}
              </button>
            </article>
          </div>
        </section>
      </main>
    </>
  );
}
